import messages from './identifier-input-lang.json';
export default {
	data() {
		return {
			showSavedAccountNumbers: false,
			inputType: 'password',
			inputVisible: false,
			webkitTextSecuritySupported: false
		};
	},
	props: {
		numberOnly: {
			default: false
		},
		value: {
			required: true
		},
		savedAccountNumbers: {
			required: true
		},
		maxlength: {
			required: true
		},
		fieldError: {
			required: true
		},
		inputId: {
			required: true
		}
	},
	i18n: { messages },
	watch: {
		value(val) {
			if (val && val.length == this.maxlength) {
				this.$emit('on-jump', this.nextRef);
			}
		}
	},
	methods: {
		validate(e) {
			// csak szamokat engedjen
			if (
				this.numberOnly &&
				e.which &&
				!e.ctrlKey &&
				!e.metaKey &&
				e.which != 8 &&
				e.which != 46 &&
				e.which != 37 &&
				e.which != 39 &&
				isNaN(String.fromCharCode(e.which))
			) {
				e.preventDefault();
			}
		},
		onPaste(e) {
			let clipboardData = e.clipboardData || window.clipboardData;
			let pasted = clipboardData.getData('Text');
			if (this.numberOnly) {
				pasted = pasted.replace(/\D/g, '');
			}
			e.preventDefault();
			this.$emit('input', pasted);
			e.target.value = pasted;
			this.$emit('paste', e);
		},
		selectAccountNumber(accountNumber) {
			this.$emit('on-select', accountNumber.identifier);
			this.closePopup();
		},
		closePopup() {
			this.showSavedAccountNumbers = false;
		},
		focusInput() {
			this.$nextTick(() => {
				this.$refs.input.focus();
			});
		},
		showIt() {
			this.inputType = this.numberOnly ? 'tel' : 'text';
			let inputValue = '';
			if (this.webkitTextSecuritySupported && this.numberOnly) {
				inputValue = this.value;
				this.$emit('input', '');
			}
			this.$nextTick(() => {
				if (this.webkitTextSecuritySupported && this.numberOnly) {
					this.$emit('input', inputValue);
				}
				this.inputVisible = true;
				this.focusInput();
			});
		},
		hideIt() {
			this.inputType = this.webkitTextSecuritySupported && this.numberOnly ? 'tel' : 'password';
			this.$nextTick(() => {
				this.inputVisible = false;
				this.focusInput();
			});
		},
		deleteAccount(identifier) {
			this.$emit('on-delete', identifier);
			if (this.savedAccountNumbers.length == 2) {
				this.closePopup();
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			let inputElem = this.$refs.input;
			this.webkitTextSecuritySupported = !!window.getComputedStyle(inputElem).webkitTextSecurity;
			this.inputType = this.webkitTextSecuritySupported && this.numberOnly ? 'tel' : 'password';
		});
	}
};
